<template>
    <div class="custom-control custom-switch">
        <input
            type="checkbox"
            class="custom-control-input"
            v-model="model"
            v-bind="$attrs"
            v-on="listeners"
            :id="id"
        />
        <label class="custom-control-label" :for="id" v-text="label"></label>
    </div>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            id: null,
        };
    },
    methods: {
        input(val) {
            this.$emit("input", val);
        },
    },
    computed: {
        listeners() {
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        label() {
            return this.value ? "On" : "Off";
        },
    },
    mounted() {
        this.id = this._uid;
    },
};
</script>

<style>
</style>